import { Box, Modal, Svg } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

import { RiderLocation } from '../../../RiderLocations/Location/Location.types';
import { RiderLocationForm } from '../../../RiderLocations/RiderLocationForm';
import {
  RiderLocationFormData,
  RiderLocationFormType,
} from '../../../RiderLocations/RiderLocationForm/RiderLocationForm.types';

const defaultValues: RiderLocationFormType = {
  primary: false,
  mustBeMet: false,
  mustBeMetProtocol: {
    locationProtocol: '',
    authorizedContactGroups: [],
  },
  locationId: undefined,
  replaceLocation: undefined,
};

interface AddLocationModalProps {
  isOpen: boolean;
  associatedLocations: RiderLocation[];
  riderSlug: string;
  onSave: (formData: RiderLocationFormData, locationDetails: RiderLocation) => void;
  onCancel: () => void;
}

export const AddLocationModal = ({
  isOpen,
  associatedLocations,
  riderSlug,
  onSave,
  onCancel,
}: AddLocationModalProps) => {
  const disabledIds = associatedLocations.map((l) => l.id.toString());

  return (
    <Modal
      open={isOpen}
      data-testid="rider-location-add-modal"
      maxWidth={'xl'}
      PaperProps={{ style: { overflowY: 'hidden' } }}
    >
      <Modal.Title>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          Add location to rider
          <CloseButton onClick={onCancel} aria-label="Close add location modal">
            <Svg height="20px" icon="close-outlined" />
          </CloseButton>
        </Box>
      </Modal.Title>
      <Modal.Content>
        <RiderLocationForm
          initialValues={defaultValues}
          onSubmit={onSave}
          disabledLocationIds={disabledIds}
          associatedLocations={associatedLocations}
          riderSlug={riderSlug}
          onCancel={onCancel}
          hideSavedLocationsInFindAndReplace
        />
      </Modal.Content>
      <Modal.Actions>
        <Button color="tertiary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" form="rider-associated-location" color="primary">
          Add
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const CloseButton = styled('div')`
  display: inline-flex;
  margin-left: auto;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background: #ddebfa;
    svg {
      color: ${colorTokens.text.hover};
    }
  }
`;
